import { css, cx } from "emotion";
import React from "react";
import MenuIcon from "@material-ui/icons/Menu";
import MailIcon from "@material-ui/icons/Mail";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import logoSHOPFROMIZY from "../../assets/images/logo-SHOPFROMIZY.png";
import SidebarDrawer from "./SidebarDrawer";
import withWidth from "@material-ui/core/withWidth";
import IconProfileGeneral from "../../assets/icons/ic_profile_general.svg";
import Dropdown from "reactstrap/lib/Dropdown";
import DropdownToggle from "reactstrap/lib/DropdownToggle";
import DropdownMenu from "reactstrap/lib/DropdownMenu";
import DropdownItem from "reactstrap/lib/DropdownItem";
import SettingsIcon from "@material-ui/icons/Settings";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { clearLocalStorage } from "../Utils/Utils";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import History from "../../History/History";
import { checkModuleAccess } from "../../Helpers/role";

const user = JSON.parse(localStorage.getItem("user"));
const token = localStorage.getItem("token");
const drawerWidth = 260;
const BaseLayout = ({
  children,
  width,
  background,
  hiddenSidebar,
  location,
  onToggleDrawer,
}) => {
  const [isMobile, setIsMobile] = React.useState(true);
  const [drawerOpen, setDrawerOpen] = React.useState(isMobile ? false : true);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const checkRouterPermissions = (state) => {
    if (!token) {
      window.location.href = "/login";
    }

    if (
      user &&
      user?.default_password &&
      window?.location?.pathname !== "/settings/security"
    ) {
      window.location.href = "/settings/security";
    }

    return token;
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleOnCloseDrawer = () => {
    setDrawerOpen(false);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleClickPengaturan = () => {
    toggleDropdown();
    History.replace(`/settings`);
  };

  React.useEffect(() => {
    checkRouterPermissions();
    if (width === "xs" || width === "sm") {
      setIsMobile(true);
      setDrawerOpen(false);
    } else {
      setIsMobile(false);
      setDrawerOpen(
        hiddenSidebar !== "" && hiddenSidebar === "true" ? false : true
      );
    }

    const handlerStorage = () => checkRouterPermissions();
    window.addEventListener("storage", handlerStorage);
    return () => {
      window.removeEventListener("storage", handlerStorage);
    };
  }, [width, hiddenSidebar]);

  React.useEffect(() => {
    if (onToggleDrawer) {
      onToggleDrawer(drawerOpen);
    }
  }, [drawerOpen, onToggleDrawer]);

  return token ? (
    <div
      className={cx(
        background === "gray"
          ? css`
              padding-top: 70px;
              min-height: 100vh;
              background-color: #eeeeee;
            `
          : css`
              padding-top: 70px;
              min-height: 100vh;
              background-color: #ffffff;
            `,
        "d-flex flex-column"
      )}
    >
      <header>
        <nav
          className={cx(
            css`
              box-shadow: 0 2px 8px 0 rgb(0 0 0 / 15%);
              -moz-box-shadow: 0 2px 8px 0 rgb(0 0 0 / 15%);
              -webkit-box-shadow: 0 2px 8px 0 rgb(0 0 0 / 15%);
              -o-box-shadow: 0 2px 8px 0 rgb(0 0 0 / 15%);
              z-index: 1201 !important;
              padding: 0px 20px !important;
            `,
            "navbar fixed-top bg-white"
          )}
        >
          <div className="d-flex justify-content-start align-items-center p-0 w-100">
            <button
              type="button"
              className={cx(
                css`
                  outline: none !important;
                `,
                "btn bg-white mr-2 p-0"
              )}
              onClick={toggleDrawer}
            >
              <MenuIcon />
            </button>
            {!isMobile && (
              <img src={logoSHOPFROMIZY} alt="logo" style={{ width: 58 }} />
            )}
            <div
              className={cx(
                css`
                  height: 56px;
                `,
                "ml-auto d-flex justify-content-end align-items-center"
              )}
            >
              {!isMobile && (
                <Dropdown
                  isOpen={dropdownOpen}
                  toggle={toggleDropdown}
                  direction="down"
                >
                  <DropdownToggle
                    className={cx(
                      css`
                        box-shadow: none !important;
                        outline: none !important;
                        border: none !important;
                        :focus {
                          box-shadow: none !important;
                          outline: none !important;
                          border: none !important;
                        }
                        :active {
                          box-shadow: none !important;
                          outline: none !important;
                          border: none !important;
                        }
                      `,
                      "h-100 border-right-1-secondary px-3 d-flex justify-content-end align-items-center border-0 rounded-0 bg-white"
                    )}
                  >
                    <div className="d-inline-block line-height-1 text-right">
                      <span className="font-12 font-bold d-block">
                        {user?.name || "Admin"}
                      </span>
                      <span className="font-9">{user?.role?.name || "-"}</span>
                    </div>
                    <img
                      src={
                        user?.type === "tenant"
                          ? user?.tenant?.logo?.square
                          : IconProfileGeneral
                      }
                      alt={user?.name}
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: 6,
                        marginLeft: 12,
                      }}
                    />
                  </DropdownToggle>
                  <DropdownMenu
                    className={cx(css`
                      margin-top: 15px !important;
                      border: none !important;
                      border-radius: 8px !important;
                      box-shadow: 0 2px 8px 0 rgb(0 0 0 / 15%) !important;
                      min-width: 200px !important;
                      padding: 16px 12px !important;
                    `)}
                  >
                    <div className="d-flex flex-column justify-content-center align-items-center mb-3">
                      <img
                        src={
                          user?.type === "tenant"
                            ? user?.tenant?.logo?.square
                            : IconProfileGeneral
                        }
                        alt={user?.name}
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: 6,
                          marginBottom: 10,
                        }}
                      />
                      <div className="d-inline-block line-height-1 text-center">
                        <span className="font-12 font-bold d-block">
                          {user?.name || "Admin"}
                        </span>
                        <span className="font-10 text-muted">
                          {user?.role?.name || "-"}
                        </span>
                      </div>
                    </div>
                    {checkModuleAccess(9) && (
                      <React.Fragment>
                        <DropdownItem divider />
                        <DropdownItem
                          className="text-left py-1 px-0 font-10"
                          onClick={handleClickPengaturan}
                        >
                          <SettingsIcon
                            className="mr-2 font-14"
                            style={{ color: "#757575" }}
                          />
                          Pengaturan
                        </DropdownItem>
                      </React.Fragment>
                    )}
                    <DropdownItem divider />
                    <DropdownItem
                      className="text-left py-1 px-0 font-10"
                      onClick={clearLocalStorage}
                    >
                      <ExitToAppIcon
                        className="mr-2 font-14"
                        style={{ color: "#757575" }}
                      />
                      Keluars
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              )}
              <div
                type="button"
                className="h-100 border-right-1-secondary px-3 d-flex justify-content-end align-items-center"
              >
                <MailIcon />
              </div>
              <div
                type="button"
                className="h-100 pl-3 pr-0 d-flex justify-content-end align-items-center"
              >
                <NotificationsNoneIcon />
              </div>
            </div>
          </div>
        </nav>
      </header>
      <main>
        <div className="d-flex justify-content-start align-items-start">
          <SidebarDrawer
            show={drawerOpen}
            onCloseAction={handleOnCloseDrawer}
            variant={isMobile ? "temporary" : "persistent"}
            drawerWidth={drawerWidth}
            isMobile={isMobile}
            onClickPengaturan={handleClickPengaturan}
            onClickKeluar={clearLocalStorage}
          />
          <div
            className={
              !isMobile && drawerOpen
                ? css`
                    margin-left: 260px !important;
                    padding: 0px 16px;
                    max-width: calc(100% - 260px) !important;
                    width: 100% !important;
                  `
                : css`
                    margin-left: 0px !important;
                    padding: 0px 16px;
                    max-width: 100% !important;
                    width: 100% !important;
                  `
            }
          >
            {children}
          </div>
        </div>
      </main>
    </div>
  ) : (
    <div
      className={cx(
        css`
          height: 100vh;
        `,
        "d-flex justify-content-center align-items-center w-100"
      )}
    >
      <h4 className="font-bold text-muted">Redirect to login page</h4>
    </div>
  );
};

export default withWidth()(BaseLayout);
